// extracted by mini-css-extract-plugin
module.exports = {"buttons":"a2c79c7e7d--buttons--nm9Gc","button":"a2c79c7e7d--button--J3n8p","plus":"a2c79c7e7d--plus--CEIzy","minus":"a2c79c7e7d--minus--FZ2iF"};